var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBetslipDefaultCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Profile default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.46836,19.665436 C23.2821597,16.4930095 20.2874299,14.0461396 16.8350951,12.6115523 C19.10516,10.7925935 20.0243272,7.64134269 19.1184108,4.78348697 C18.2124944,1.92563125 15.6839981,1.77635684e-15 12.8373384,1.77635684e-15 C9.99067876,1.77635684e-15 7.46218244,1.92563125 6.55626605,4.78348697 C5.65034967,7.64134269 6.5695168,10.7925935 8.83958172,12.6115523 C5.39253864,14.0500046 2.40255391,16.4963441 0.218127083,19.665436 C-0.131517907,20.1427996 -0.052450683,20.8293965 0.39528026,21.203783 C0.575525057,21.3586982 0.800897371,21.4426736 1.0330317,21.4414278 C1.34872637,21.4372727 1.64673311,21.2863404 1.84793632,21.0286866 C5.23746711,16.4511663 9.04035532,14.0373373 12.8432435,14.0373373 C16.6461317,14.0373373 20.4372097,16.4511663 23.8385507,21.0286866 C24.201627,21.4768222 24.8339469,21.541696 25.2715037,21.1757025 C25.7090605,20.809709 25.7959274,20.143273 25.46836,19.665436 L25.46836,19.665436 Z M8.24907113,7.05849493 C8.23471581,5.10254691 9.33626967,3.33072488 11.0385678,2.57165874 C12.740866,1.81259259 14.7074449,2.21631368 16.0185925,3.59401334 C17.3297401,4.97171301 17.7263047,7.05108538 17.0228245,8.85966818 C16.3193443,10.668251 14.654864,11.848649 12.8078129,11.848649 C10.3012015,11.8555628 8.26208399,9.71294245 8.24907113,7.05849493 L8.24907113,7.05849493 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Betslip-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-betslip-redesign",
    transform: "translate(-491.000000, -232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Betslip-after-Login-(updated)-Copy",
    transform: "translate(475.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-default",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/profile",
    transform: "translate(7.166667, 8.108108)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#204293",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8icon-color/selected-race",
    mask: "url(#mask-2)",
    fill: "#122C68"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.166667, -3.783784)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28,
    height: 30.2702703
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetslipDefaultCard);
export default __webpack_public_path__ + "static/media/betslip_default_card.43f8ff5f836300fae2fa45d25a69a673.svg";
export { ForwardRef as ReactComponent };